var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrap"},[_c('Banner'),_c('Designer'),_c('FeaturedMedia'),_c('Payment'),_c('DomainPixel'),_c('AnalyticsData'),_c('QuickEasy'),_c('CreateDestyStore'),_c('Support')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }